<template>
  <router-view></router-view>
</template>

<script>
import { getEmail, getEmailBoAPI } from '@/services/email.service'

export default {
  name: 'App',
  async mounted() {
    const emailToken = this.$route.query.email_token
    const emailTokenBoAPI = this.$route.query.email_token_boapi

    if (emailToken) {
      const typeForLeadTemplate = ['lead_first_email', 'dealer_first_reminder']
      const typeForDealerTemplate = ['dealer_first_email', 'dealer_last_reminder']
      const typeForCustomerTemplate = ['customer_feedback', 'customer_feedback_unfortunately']

      getEmail(emailToken).then(email => {
        if (email.locale) {
          this.$i18n.locale = email.locale
        }
        if (email.type === 'internal') {
          this.$router.push({
            name: 'internal',
            params: {
              email,
            },
          })
        }
        if (email.type === 'report_global') {
          this.$router.push({
            name: 'global',
            params: {
              email,
            },
          })
        }
        if (email.type === 'report_global_pdf') {
          this.$router.push({
            name: 'global-pdf',
            params: {
              email,
            },
          })
        }
        if (email.type === 'report_local') {
          this.$router.push({
            name: 'local',
            params: {
              email,
            },
          })
        }
        if (email.type === 'report_local_pdf') {
          this.$router.push({
            name: 'local-pdf',
            params: {
              email,
            },
          })
        }
        if (email.type === 'external') {
          this.$router.push({
            name: 'external',
            params: {
              email,
            },
          })
        }
        if (email.type === 'user-express') {
          this.$router.push({
            name: 'userExpress',
            params: {
              email,
            },
          })
        }
        if (typeForLeadTemplate.includes(email.type)) {
          this.$router.push({
            name: 'lpe-lead-first',
            params: {
              email,
            },
          })
        }
        if (typeForDealerTemplate.includes(email.type)) {
          this.$router.push({
            name: 'lpe-dealer-first',
            params: {
              email,
            },
          })
        }
        if (typeForCustomerTemplate.includes(email.type)) {
          this.$router.push({
            name: 'lpe-customer',
            params: {
              email,
            },
          })
        }
      })
    } else if (emailTokenBoAPI) {
      const email = await getEmailBoAPI(emailTokenBoAPI)

      if (email.type === 'weekly_lead_report') {
        this.$router.push({
          name: 'lead-weekly',
          params: {
            email,
          },
        })
      }
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/global.scss';
#gtr-emails-html {
  background-color: $bg-main;
  color: $font-color-main;
  font-family: $font-family-default;
}
</style>
